import { Params } from '@angular/router';
import { isEmpty } from 'lodash';

interface CommonSite {
    isExtremelyLarge: boolean;
    siteId: number;
}

export const LOAD_ALL_RESULTS_QUERY_PARAMETER = 'load-all-results';
export const ACCESSION_FILTER_QUERY_PARAMETER = 'accessionNumber';

export function getOptionalParametersForSTRQuery(loadAllQueryParam: boolean, site: CommonSite, queryParams: Params ) {
    const doLoadAll = !(site.isExtremelyLarge) || loadAllQueryParam;
    if (doLoadAll) {
        return '';
    }

    let selectedAccessions: string[] = null;

    const selectedAccessionJson = queryParams[ACCESSION_FILTER_QUERY_PARAMETER];
    if (selectedAccessionJson) {
        try {
            const accessions: string[] = JSON.parse(selectedAccessionJson);
            selectedAccessions = isEmpty(accessions) ? null : accessions;
        } catch {
            console.warn('invalid accession number in query parameters');
        }
    }

    let optionalQueryParams = '';

    if (selectedAccessions) {
        optionalQueryParams = selectedAccessions.map(accession => `&selectedAccessions=${accession}`).join('');
    }

    return `?loadAll=false${optionalQueryParams}`;
}